import React, { useState } from "react";
import BannerSkeleton from "./Skeletons/BannerSkeleton.jsx";
import styled from "@emotion/styled";

const PictureWrapper = styled.picture`
  display: ${(props) => (props.isLoaded ? "block" : "none")};
`;

const EventBanner = ({
  bannerInfo: { playImage, alternateImage },
  title,
  loading,
}) => {
  const [imgIsLoaded, setImgIsLoaded] = useState(false);

  const handleImageLoad = async (e) => {
    try {
      // Wait for the image to be fully decoded
      await e.target.decode();
      // Only then set it as loaded
      setImgIsLoaded(true);
    } catch {
      // If decode fails, still show the image
      setImgIsLoaded(true);
    }
  };

  return (
    <div className="r_banner">
      {(loading || !imgIsLoaded) && <BannerSkeleton />}
      {
        <PictureWrapper isLoaded={imgIsLoaded}>
          <source
            media="(max-width:767px)"
            srcSet={alternateImage || playImage}
          />
          <img src={playImage} alt={title} onLoad={handleImageLoad} />
        </PictureWrapper>
      }
    </div>
  );
};

export default EventBanner;
